import { render } from "./partnersComponent.vue?vue&type=template&id=29cfdfd0"
import script from "./partnersComponent.vue?vue&type=script&lang=js"
export * from "./partnersComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__